import { createFileRoute } from "@tanstack/react-router";
import Settings from "@/pages/Settings";
import { AuthenticationMethod } from "@aqualis/common/types";
import { AuthProvider } from "@/contexts/auth-context";

export const Route = createFileRoute("/settings")({
  component: SettingsPage,
});

function SettingsPage() {
  return (
    <AuthProvider authMethod={AuthenticationMethod.Cookie}>
      <Settings />
    </AuthProvider>
  );
}
